<template>
    <b-card class="d-flex align-items-center justify-content-center sticky">
        <div class="vehicle-reference-model-drawer d-flex flex-column align-items-center">
            <div class="d-flex align-items-center">
                <template v-if="frontAxles.length">
                    <div v-for="tire in (frontAxles[0].tire / 2)" :key="'ftl'+tire" class="tire vehicle-border left"></div>
                </template>
                <div class="d-flex align-items-center vehicle-front vehicle-border">
                    <div v-if="frontAxles[0] && frontAxles[0].tire > 0" class="tire-line-text">Ön 1. Dingil</div>
                </div>
                <template v-if="frontAxles.length">
                    <div v-for="tire in (frontAxles[0].tire / 2)" :key="'ftr'+tire" class="tire vehicle-border right"></div>
                </template>
            </div>
            <div v-if="!merge" class="d-flex">
                <div class="d-flex flex-column justify-content-end">
                    <div class="d-flex justify-content-end" v-for="(axle,index) in frontAxles.slice(1)" :key="'fbal'+index">
                        <div v-for="tire in (axle.tire / 2)" class="tire vehicle-border back left" :key="'fbtl'+tire"></div>
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-end vehicle-front-back vehicle-border">
                    <div class="tire-line-text back" v-for="(axle,index) in frontAxles.slice(1)" :key="'fbtt'+index" >
                        <template v-if="axle.tire > 0">Ön {{index + 2}}. Dingil</template>
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-end">
                    <div class="d-flex justify-content-start" v-for="(axle,index) in frontAxles.slice(1)" :key="'fbar'+index">
                        <div v-for="tire in (axle.tire / 2)" class="tire vehicle-border back right" :key="'fbtr'+tire"></div>
                    </div>
                </div>
            </div>
            <div class="d-flex">
                <div class="d-flex flex-column justify-content-end">
                    <div class="d-flex justify-content-end" v-for="(axle,index) in backAxles" :key="'bal'+index">
                        <div v-for="tire in (axle.tire / 2)" class="tire vehicle-border back left" :key="'btl'+tire"></div>
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-end vehicle-back vehicle-border" :class="{merge:merge}">
                    <div class="tire-line-text back" v-for="(axle,index) in backAxles.filter(ba=>ba.tire>0)" :key="'btt'+index">
                        <template v-if="axle.tire > 0">Arka {{index + 1}}. Dingil</template>
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-end">
                    <div class="d-flex justify-content-start" v-for="(axle,index) in backAxles" :key="'bar'+index">
                        <div v-for="tire in (axle.tire / 2)" class="tire vehicle-border back right" :key="'btr'+tire"></div>
                    </div>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
export default {
    components:{
        BCard
    },
    props:{
        merge:{
            type:Boolean,
            default:false
        },
        frontAxles:{
            type:Array,
            default:()=>[]
        },
        backAxles:{
            type:Array,
            default:()=>[]
        }
    },
}
</script>

<style>
:root{
    --drawer-min-width:285px;
    --vehicle-front-width:165px;
    --vehicle-front-height:99px;
    --vehicle-back-width:99px;
    --vehicle-back-height:210px;
    --vehicle-font-back-width:99px;
    --vehicle-font-back-height:160px;
    --vehicle-tire-width:15px;
    --vehicle-tire-height:40px;
    --vehicle-tire-back-margin-bottom:10px;
}

.sticky{
    position:sticky;
    top:1.5rem;
}

.vehicle-reference-model-drawer{
    min-width:var(--drawer-min-width);
}

.vehicle-front{
    height: var(--vehicle-front-height);
    width: var(--vehicle-front-width);
    border-radius: 0.5rem;;
    border: 2px solid;
}

.vehicle-front-back{
    height: var(--vehicle-font-back-height);
    width: var(--vehicle-font-back-width);
    border-radius: 0px 0px 0.5rem 0.5rem;
    border: 2px solid;
    border-top: 0px;
}

.vehicle-back{
    height: var(--vehicle-back-height);
    width:  var(--vehicle-back-width);
    border-radius: 0.5rem;
    border: 2px solid;
    margin-top: 0.5rem;
}


.vehicle-back.merge{
    border-top: 0px;
    margin-top: 0px;
    border-radius: 0px 0px 0.5rem 0.5rem;
}

.tire-line-text{
    height: var(--vehicle-tire-height);
    line-height: var(--vehicle-tire-height);
    text-align: center;
    width: 100%;
    font-size: 0.8rem;
    font-weight: bold;
}

.tire-line-text.back{
    margin-bottom: calc(var(--vehicle-tire-back-margin-bottom) - 1px);
}

.tire{
    height: var(--vehicle-tire-height);
    width: var(--vehicle-tire-width);
    border: 2px solid;
}

.tire.back{
    margin-bottom: var(--vehicle-tire-back-margin-bottom);
}

.tire.left{
    border-right: 0px;
}

.tire.right{
    border-left: 0px;
}

.vehicle-border{
    border-color: #343d55;
}

.dark-layout .vehicle-border{
    border-color :#f3f2f7;
}
</style>